import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'Containers/Common/Modal';
import HoveredInfoIcon from 'Containers/Common/HoveredInfoIcon';
import SpinnerSmall from 'Containers/Common/SpinnerSmall';
import TaglioPreviewCarousel from './TaglioPreviewCarousel';
import modalStyles from '../TaskInfoModal.module.scss';
import styles from './ExploreTaglioRow.module.scss';

const SectionTitle = () => {
  const { t } = useTranslation();
  return (
    <div className={modalStyles.info_title} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      {t('scheduler.taskInfoModal.exploreHaircutSection')}
      <HoveredInfoIcon description={t('scheduler.taskInfoModal.exploreHaircutSectionDescription')} />
    </div>
  );
};

const ExploreTaglioRow = ({ taglio, loading, fetchFailed, hasIdTaglio }) => {
  const { t } = useTranslation();
  const [previewOpen, setPreviewOpen] = useState(false);

  const slides = useMemo(
    () => (taglio?.immagini ?? []).filter((url) => !!url),
    [taglio?.immagini],
  );

  const thumbUrl = taglio?.immagini?.[0] || slides[0] || null;

  if (!hasIdTaglio) {
    return null;
  }

  if (loading) {
    return (
      <div className={modalStyles.info_block}>
        <SectionTitle />
        <SpinnerSmall />
      </div>
    );
  }

  if (fetchFailed || !taglio) {
    return (
      <div className={modalStyles.info_block}>
        <SectionTitle />
        <p className={styles.unavailable}>{t('scheduler.taskInfoModal.exploreHaircutUnavailable')}</p>
      </div>
    );
  }

  return (
    <>
      <div className={modalStyles.info_block}>
        <SectionTitle />
        <button
          type="button"
          className={styles.row}
          onClick={() => setPreviewOpen(true)}
          aria-label={t('scheduler.taskInfoModal.exploreHaircutPreview')}
        >
          <div className={styles.thumb}>
            {thumbUrl ? (
              <img src={thumbUrl} alt="" className={styles.thumb_img} />
            ) : (
              <div className={styles.thumb_placeholder} />
            )}
          </div>
          <span className={styles.name}>{taglio.nome}</span>
        </button>
      </div>

      <Modal
        isModalOpen={previewOpen}
        setIsModalOpen={setPreviewOpen}
        width="360px"
        maxWidth="92vw"
        showCloseBtn
        centered
      >
        <div className={styles.preview} onClick={(e) => e.stopPropagation()}>
          <TaglioPreviewCarousel
            slides={slides}
            resetKey={previewOpen ? taglio.idTaglio : 'closed'}
          />
          <div className={styles.preview_name}>{taglio.nome}</div>
          {taglio.descrizione ? (
            <p className={styles.preview_desc}>{taglio.descrizione}</p>
          ) : null}
        </div>
      </Modal>
    </>
  );
};

export default ExploreTaglioRow;
